module.exports = " <button class=md-button @click=onClick($event)> <slot></slot> </button> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/md-button/index.vue
// module id = 237
// module chunks = 0